import { render, staticRenderFns } from "./PersonalDetailsSection.vue?vue&type=template&id=19226fdf&scoped=true"
import script from "./PersonalDetailsSection.vue?vue&type=script&lang=js"
export * from "./PersonalDetailsSection.vue?vue&type=script&lang=js"
import style1 from "./PersonalDetailsSection.vue?vue&type=style&index=1&id=19226fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19226fdf",
  null
  
)

export default component.exports